var map = {
	"./bg.png": "2cf3",
	"./card.png": "3a1c",
	"./card2.png": "c300",
	"./close.png": "00e9",
	"./coin.png": "2c6d",
	"./diamond_vip.png": "7a0c",
	"./gold_vip.png": "8619",
	"./item_bg.png": "814c",
	"./item_bg1.png": "2b3d",
	"./item_bg2.png": "7791",
	"./item_bg_select.png": "6de1",
	"./money.png": "aaf5",
	"./prize_bg.png": "c3c9",
	"./record-top.png": "4782",
	"./redpack.png": "ed87",
	"./reward_bg.png": "45a2",
	"./rule_bg.png": "d2e0",
	"./silver_vip.png": "39ea",
	"./thanks.png": "f13d",
	"./title.png": "67ec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0c95";